import React, { memo } from 'react';
import PropTypes from 'prop-types';
import style from '../style/components/ButtonSecondary.module.scss';

const ButtonSecondary = ({ children, ...props }) => (
  <button className={style.buttonSecondary} type="button" {...props}>
    {children}
  </button>
);

ButtonSecondary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(ButtonSecondary);
